import type { ReportPreviewLayout } from 'app/modules/analytics/modules/reports/constants/reportPreviewPageShellClassName';

interface Props {
  reportName?: string;
  rangeLabel?: string;
  layout?: ReportPreviewLayout;
}

const ReportPreviewNameAndPeriod = ({
  reportName,
  rangeLabel,
  layout = 'modal',
}: Props) => {
  const trimmedName = reportName?.trim() ?? '';
  const showName = trimmedName.length > 0;

  if (!showName && !rangeLabel) {
    return null;
  }

  return (
    <div
      className={
        layout === 'export'
          ? 'tw-flex tw-min-w-0 tw-max-w-[50%] tw-flex-col tw-items-end tw-gap-1'
          : 'tw-flex tw-shrink-0 tw-flex-col tw-items-end tw-gap-1'
      }
    >
      {showName ? (
        <span
          className={
            layout === 'export'
              ? 'analytics-report-page-header-name tw-break-words tw-text-right tw-text-xs tw-font-medium tw-text-grayscale-100'
              : 'tw-max-w-[500px] tw-truncate tw-text-xs tw-font-medium tw-text-grayscale-100'
          }
        >
          {trimmedName}
        </span>
      ) : null}
      {rangeLabel ? (
        <span className="tw-shrink-0 tw-text-sm tw-font-medium tw-text-grayscale-180">
          {rangeLabel}
        </span>
      ) : null}
    </div>
  );
};

export default ReportPreviewNameAndPeriod;
